// Audio format helpers — pick a MIME the browser actually supports and keep
// the Blob/extension consistent with what MediaRecorder produced (iOS/Safari safe).
const CANDIDATES = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/mp4;codecs=mp4a.40.2",
  "audio/mp4",
  "audio/ogg;codecs=opus",
];

export function pickAudioMime() {
  if (typeof MediaRecorder === "undefined" || !MediaRecorder.isTypeSupported) return "";
  for (const c of CANDIDATES) {
    try { if (MediaRecorder.isTypeSupported(c)) return c; } catch (e) {}
  }
  return "";
}

export function extForMime(mime) {
  const m = (mime || "").toLowerCase();
  if (m.includes("webm")) return "webm";
  if (m.includes("mp4") || m.includes("m4a") || m.includes("aac") || m.includes("mp4a")) return "m4a";
  if (m.includes("ogg")) return "ogg";
  if (m.includes("mpeg") || m.includes("mp3")) return "mp3";
  if (m.includes("wav")) return "wav";
  return "webm";
}
